<template>
  <div class="compressed-content">
    <div class="page-question">
      <h3>
        Have you been diagnosed with familial hypercholesterolemia?
        <span class="information-popover" v-b-popover.hover.auto="hypercholesterolemiaInformation">i</span>
      </h3>
    </div>

    <div class="mb-4">
      <b>Note:</b> FH is a diagnosed genetic condition and not simply high <br />
      cholesterol. See pop-out for more information about FH.
    </div>
    
    <v-form-group class="card-selector page-buttons" :validator="$v.hadDiagnosis">
      <b-form-radio v-model="survey.bloodBiochemistry.hypercholesterolemia.hadDiagnosis" name="fh"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.hypercholesterolemia.hadDiagnosis" name="fh"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { hypercholesterolemiaInformation } from '@/constants';

  export default {
    mixins: [formMixin],

    data() {
      return {
        highestCholesterolRange: null,
        hypercholesterolemiaInformation
      };
    },

    validations: {
      hadDiagnosis: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadDiagnosis() { return this.survey.bloodBiochemistry.hypercholesterolemia.hadDiagnosis }
    }
  };
</script>